export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/bf.d68c8be5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};